import { closeModal, openModal, ModalContent } from './globalModal'
import { createSlice } from '@reduxjs/toolkit'

export const initialState = { open: false, canClose: true }

//TODO This slice is old and should be deleted once the actions are replaced with new existing ones
const loginModalSlice = createSlice({
    name: 'loginModal',
    initialState,
    reducers: {
        open: (_, { payload }) => {
            return { open: true, canClose: payload ? payload.canClose : true }
        },
        close: () => {
            return { open: false, canClose: true }
        },
    },
})

const { reducer } = loginModalSlice // Extract the action creators object and the reducer
export const openLoginModal = payload => openModal({ ...payload, content: ModalContent.SIGNUP })
export const closeLoginModal = () => closeModal()
export default reducer

//Selectors
export const isLoginModalOpen = store => {
    return store.loginModal.open
}

export const canCloseLogin = store => {
    return store.loginModal.canClose
}
